import { HorizontalNavigationTab } from "@risalabs_frontend_org/oasis-ui-kit";
import type { EligibilitySelectOption } from "../../data-model/eligibilityOptions";
import "./PatientEligibilityNavigation.scss";

/** Props for the eligibility mapping worklist tab strip. */
interface PatientEligibilityMappingNavigationProps {
  tabs: EligibilitySelectOption[];
  selectedTab: string;
  onTabChange: (tabValue: string) => void;
}

/**
 * Navigation strip for the Patient Eligibility Mapping page.
 *
 * @input props.tabs - Tab options from the eligibility options API
 * @input props.selectedTab - Currently selected tab value
 * @input props.onTabChange - Called when the operator selects a tab
 * @return Navigation labels for eligibility mapping sections
 */
const PatientEligibilityMappingNavigation = ({
  tabs,
  selectedTab,
  onTabChange,
}: PatientEligibilityMappingNavigationProps) => {
  if (tabs.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 border-b border-primaryGray-15 patient-eligibility-mapping--navigation">
      <HorizontalNavigationTab
        onChange={(value) => onTabChange(String(value))}
        tabs={tabs.map((tab) => ({
          label: tab.label,
          value: tab.value,
          rightContent:
            tab.count == null ? undefined : (
              <span
                className={`inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-tiny font-semibold ${
                  tab.value === selectedTab
                    ? "bg-[#0056D6] text-white"
                    : "bg-primaryGray-14 text-primaryGray-5"
                }`}
              >
                {tab.count}
              </span>
            ),
        }))}
        truncate
        value={selectedTab}
        activeBackgroundColor="#F3F8FF"
        activeColor="#0056D6"
        rounded={true}
        backgroundColor="white"
      />
    </div>
  );
};

export default PatientEligibilityMappingNavigation;
